var map = {
	"./banknote-with-dollar-sign.png": "8a24",
	"./bar-chart.png": "dbd0",
	"./bust-in-silhouette.png": "af41",
	"./classical-building.png": "7f6e",
	"./confused.png": "2edc",
	"./custom-distribution.png": "e6d8",
	"./dollar-sign.png": "1c08",
	"./ear-of-rice.png": "e431",
	"./fountain-pen.png": "e9d8",
	"./happy.png": "cb38",
	"./incoming-envelope.png": "05fc",
	"./memo.png": "9fff",
	"./money-bag.png": "23d1",
	"./money-with-wings.png": "21c2",
	"./page-facing-up.png": "0d6e",
	"./party-popper.png": "f9bd",
	"./waving-hand-sign.png": "d93f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cf40";